<template>
  <div class="filter">
    <div :class="{ active: showList }" class="single-select boxgroup-parent">
      <label class="label-filters hidden-xs"> Sort by... </label>
      <div class="single-select__button-wrapper">
        <button class="button toggle" @click="listToggle">
          <span>
            {{ selectedOption }}
          </span>
          <i class="icon icon--opens">
            <Icon name="fa6-solid:chevron-right" />
          </i>
        </button>
      </div>
      <div class="boxgroup-wrapper">
        <div class="boxgroup-wrapper__scrolling">
          <button class="button return visible-xs" @click="listToggle">
            <i class="icon">
              <Icon name="fa6-solid:chevron-left" />
            </i>
            <span> Return to Filters </span>
          </button>
          <FormKit
            id="the-sort-select"
            v-model="valueProxy"
            :options="options"
            fieldset-class="boxgroup"
            label-class="formkit-label--after"
            name="the-sort-select"
            type="radio"
            @mouseup="listToggle"
          />
        </div>
      </div>
      <div class="boxgroup-parent__fill-behind" @click="listToggle" />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: {
    by: string
    options: { label: string; value: string }[]
  }
}>()
const emit = defineEmits(['update:modelValue'])
const showList = ref(false)
const defaultLabel = ref('Sort by...')
const options = computed(() => props.modelValue.options)
const valueProxy = computed({
  get: () => props.modelValue.by,
  set: (value) => {
    const updatedValue = { ...props.modelValue, by: value }
    emit('update:modelValue', updatedValue)
  },
})
const selectedOption = computed(
  () =>
    options.value?.find((option) => option.value === valueProxy.value)?.label ||
    defaultLabel.value,
)

function listToggle() {
  showList.value = !showList.value
}
</script>

<style lang="less" scoped>
.single-select {
  .relative();
  .text-left();

  .single-select__button-wrapper {
    .relative();
    .flex();

    margin: 0;
    border-left: @1px solid @color-fill-divide;

    @media @tablet {
      border: @1px solid @color-fill-divide;
    }

    button {
      .round(0);

      flex: 1 1 auto;
      border: 0;
      background: transparent;
      padding: @gutter-xs @gutter @gutter-xs 0;
      color: @color-text-body;
      max-width: 100%;

      span {
        .font-size(16, 36);
        .overflow-text();

        max-width: 100%;
        padding: 0 @gutter;
      }

      &.toggle {
        .justify-between();

        flex-grow: 1;

        .icon {
          padding: 0;
          transform: rotate(90deg);
        }
      }
    }
  }
}
</style>
